/*eslint-disable*/
import{ Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { Line, Bar } from "react-chartjs-2";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";


import React from "react";

import WeatherIcon from "./WeatherIcon.jsx"



{/*https://www.iconfinder.com/icons/2671740/hot_sun_sunny_weather_icon*/}

class SmallWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

      const formatText = this.props.sun.split("\n").map((item , i)=>(
        <p key={this.props.title + i}>{item}</p>
      ));

        return (
            <>
            <div style={{marginBottom:"30px"}}>
              <Card className="card-chart">
                <CardBody>
                  <div
                    className="chart-area"
                    style={{height:"70px",textAlign:"center"}}>
                    <div style={{height:"100%", float:"left"}}>
                      <WeatherIcon id={this.props.weatherIconID} color={this.props.currentMode}/>
                    </div>
                    <div style={{height:"100%",display:"flex", flexDirection:"column"}}>
                      <p>{this.props.title}</p>
                      <div style={{height:"100%", display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <p style={{fontWeight: "normal", fontSize:"1.5em", textTransform: "capitalize"}}>
                          {this.props.info}
                        </p>
                        <div style={{fontWeight: "normal", fontSize:"1.2em", textTransform: "capitalize"}}>
                          {formatText}
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>


            </>
        );
    }
}

 export default SmallWidget
